export const GET_GENERIC_NOTIFICATION_REQUEST =
  'GET_GENERIC_NOTIFICATION_REQUEST';
export const GET_GENERIC_NOTIFICATION_SUCCESS =
  'GET_GENERIC_NOTIFICATION_SUCCESS';
export const GET_GENERIC_NOTIFICATION_FAILURE =
  'GET_GENERIC_NOTIFICATION_FAILURE';
